import {
    Card, CardContent
} from '@material-ui/core'
import {
    AccessAlarmOutlined, AddCircle, DeleteForever, Edit
} from '@material-ui/icons'
import * as React from 'react'
import { useHistory } from 'react-router-dom'

import { cardStyles } from '../../styles/CardStyles'

export const CreateEscapeRoomCardView: React.FC = () => {
    const styles = cardStyles()
    const history = useHistory()

    return (
        <div>
            <div className={styles.wrapperER}>
                <div>
                    <AccessAlarmOutlined style={{ color: '#161616' }}/>
                </div>
                <div className={styles.editIconWrapper}>
                    <div style={{ marginRight: 20 }}>
                        <Edit style={{ color: '#161616', cursor: 'pointer' }}/>
                    </div>
                    <div>
                        <DeleteForever style={{ color: '#161616', cursor: 'pointer' }}/>
                    </div>
                </div>
            </div>
            <div className={styles.eRoomCardCreate}>
                <Card className={styles.createCard}>

                    <CardContent className={styles.cardContentWrapper}>
                        <AddCircle
                            onClick={() => history.push('/opret-ny-escape-room')}
                            className={styles.createBtn}/>
                        <small>Opret Ny</small>
                    </CardContent>

                </Card>
            </div>
        </div>
    )
}
